(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[962],{

/***/ 6907:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[permalink]",
      function () {
        return __webpack_require__(9814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _permalink_; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXProvider": function() { return MDXProvider; },
  "useMDXComponents": function() { return useMDXComponents; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/idle-callback-polyfill.js
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
if (typeof window !== 'undefined') {
    window.requestIdleCallback =
        window.requestIdleCallback ||
            function (cb) {
                var start = Date.now();
                return setTimeout(function () {
                    cb({
                        didTimeout: false,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - start));
                        },
                    });
                }, 1);
            };
    window.cancelIdleCallback =
        window.cancelIdleCallback ||
            function (id) {
                clearTimeout(id);
            };
}


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var dist_jsx_runtime = __webpack_require__(2746);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/lib/index.js
/**
 * @import {MDXComponents} from 'mdx/types.js'
 * @import {Component, ReactElement, ReactNode} from 'react'
 */

/**
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Readonly<MDXComponents>} currentComponents
 *   Current components from the context.
 * @returns {MDXComponents}
 *   Additional components.
 *
 * @typedef Props
 *   Configuration for `MDXProvider`.
 * @property {ReactNode | null | undefined} [children]
 *   Children (optional).
 * @property {Readonly<MDXComponents> | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that creates them (optional).
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context (default: `false`).
 */



/** @type {Readonly<MDXComponents>} */
const emptyComponents = {}

const MDXContext = react.createContext(emptyComponents)

/**
 * Get current components from the MDX Context.
 *
 * @param {Readonly<MDXComponents> | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that creates them (optional).
 * @returns {MDXComponents}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react.useContext(MDXContext)

  // Memoize to avoid unnecessary top-level context changes
  return react.useMemo(
    function () {
      // Custom merge via a function prop
      if (typeof components === 'function') {
        return components(contextComponents)
      }

      return {...contextComponents, ...components}
    },
    [contextComponents, components]
  )
}

/**
 * Provider for MDX context.
 *
 * @param {Readonly<Props>} properties
 *   Properties.
 * @returns {ReactElement}
 *   Element.
 * @satisfies {Component}
 */
function MDXProvider(properties) {
  /** @type {Readonly<MDXComponents>} */
  let allComponents

  if (properties.disableParentContext) {
    allComponents =
      typeof properties.components === 'function'
        ? properties.components(emptyComponents)
        : properties.components || emptyComponents
  } else {
    allComponents = useMDXComponents(properties.components)
  }

  return react.createElement(
    MDXContext.Provider,
    {value: allComponents},
    properties.children
  )
}

;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */




/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...dist_jsx_runtime.jsxRuntime } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(MDXProvider, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}

;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/index.js
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */



// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
;// CONCATENATED MODULE: ./components/SeniorsJuniorsDemoSimulationAsync.tsx

const DemoSimulation = dynamic_default()(()=>Promise.all(/* import() | SeniorsJuniorsDemoSimulation */[__webpack_require__.e(78), __webpack_require__.e(370)]).then(__webpack_require__.bind(__webpack_require__, 6307)).then((m)=>m.DemoSimulation), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6307)
            ]
    }
});

// EXTERNAL MODULE: ./components/atoms/LinkUnderlineEffect.tsx
var LinkUnderlineEffect = __webpack_require__(8683);
;// CONCATENATED MODULE: ./images/calendar.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgCalendar = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
})));

/* harmony default export */ var calendar = (SvgCalendar);
;// CONCATENATED MODULE: ./images/document-text.svg
var document_text_path;

function document_text_extends() { document_text_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_text_extends.apply(this, arguments); }



const SvgDocumentText = props => /*#__PURE__*/react.createElement("svg", document_text_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), document_text_path || (document_text_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z"
})));

/* harmony default export */ var document_text = (SvgDocumentText);
;// CONCATENATED MODULE: ./images/external-link.svg
var external_link_path;

function external_link_extends() { external_link_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return external_link_extends.apply(this, arguments); }



const SvgExternalLink = props => /*#__PURE__*/react.createElement("svg", external_link_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), external_link_path || (external_link_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})));

/* harmony default export */ var external_link = (SvgExternalLink);
;// CONCATENATED MODULE: ./images/presentation-chart-line.svg
var presentation_chart_line_path;

function presentation_chart_line_extends() { presentation_chart_line_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return presentation_chart_line_extends.apply(this, arguments); }



const SvgPresentationChartLine = props => /*#__PURE__*/react.createElement("svg", presentation_chart_line_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), presentation_chart_line_path || (presentation_chart_line_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m7 12 3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4z"
})));

/* harmony default export */ var presentation_chart_line = (SvgPresentationChartLine);
;// CONCATENATED MODULE: ./images/terminal.svg
var terminal_path;

function terminal_extends() { terminal_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return terminal_extends.apply(this, arguments); }



const SvgTerminal = props => /*#__PURE__*/react.createElement("svg", terminal_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), terminal_path || (terminal_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m8 9 3 3-3 3m5 0h3M5 20h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
})));

/* harmony default export */ var terminal = (SvgTerminal);
;// CONCATENATED MODULE: ./images/video.svg
var video_path;

function video_extends() { video_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_extends.apply(this, arguments); }



const SvgVideo = props => /*#__PURE__*/react.createElement("svg", video_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "0 0 24 24"
}, props), video_path || (video_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 10 4.553-2.276A1 1 0 0 1 21 8.618v6.764a1 1 0 0 1-1.447.894L15 14M5 18h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2z"
})));

/* harmony default export */ var video = (SvgVideo);
;// CONCATENATED MODULE: ./components/molecules/Timeline.tsx







const NBSP = "\xa0";
const items = [
    {
        date: "2021.02.23",
        stillOn: true,
        title: "Type of Web na YouTube",
        subtitle: "Kanał Type of Web na YouTube",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/c/Typeofweb/videos"
            }
        ]
    },
    {
        date: "2020.01.26",
        stillOn: true,
        title: "Śniadanie z Programowaniem",
        subtitle: "Prowadzący od odcinka #21 aż do dzisiaj",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=OdYAkiCsgAY"
            }
        ]
    },
    {
        date: "2021.07.22",
        title: "devmentor.pl",
        subtitle: "Czas na TypeScript. Umacniający się język programowania",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=TFQBb4r207c"
            }
        ]
    },
    {
        date: "2021.06.22",
        title: "Junior Senior #16",
        subtitle: "Zaawansowany TypeScript",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=WDCNEe4X8PE"
            }
        ]
    },
    {
        date: "2021.04.09",
        title: "Escola Talks",
        subtitle: "Funkcyjny TypeScript Node.js Live Coding. Mattermost Tempo integration",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=Tlodk6k3alU"
            }
        ]
    },
    {
        date: "2020.12.30",
        title: "Przeprogramowani ft. Gość #6",
        subtitle: "Front-End 2025, czyli o tym co nadchodzi",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=JU9hfj3QX0g"
            }
        ]
    },
    {
        date: "2020.12.19",
        title: "Require Podcast | require(#25)",
        subtitle: "JS w 2020 - Podsumowanie feat. Michał z ToW",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=G0Zp6ykWDRg"
            }
        ]
    },
    {
        date: "2020.09.10",
        title: "Typescript z Type of Web (podejście drugie)",
        subtitle: "Od Wordpressa przez Backbone.js, Angular do React. Skad pomysl na książkę o Typescript?",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=rico0ATwwOY"
            }
        ]
    },
    {
        date: "2020.09.10",
        title: "TypeScript: rewolucja czy ewolucja - JSDżem LIVE",
        subtitle: "Rozmowa o tym, co daje TypeScript",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=O8xhIdVOapw"
            }
        ]
    },
    {
        date: "2020.09.03",
        title: "Developer Wannabe LIVE",
        subtitle: "„O Typescript z Type of Web” – rozmowa z Jędrzejem Paulusem",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=CmzGJiBwpTg"
            }
        ]
    },
    {
        date: "2020.09.02",
        title: "Porozmawiajmy o IT 079",
        subtitle: "Rozmowa na temat TypeScripta z Krzysztofem Kempińskim",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=jzMms8YdPIc"
            }
        ]
    },
    {
        date: "2020.08.19",
        title: "Quiz z Just Join IT!",
        subtitle: "Rozmowa na temat szkoleń i bootcamp\xf3w",
        links: [
            {
                kind: "video",
                value: "https://www.youtube.com/watch?v=_W3b8w8xIJo"
            }
        ]
    },
    {
        date: "2019.07.04",
        title: `Across Stack #4 API w Hapi i TypeScript`,
        subtitle: `Webinar dla infoshare Academy`,
        links: [
            {
                kind: "video",
                value: `https://www.youtube.com/watch?v=k1-CIR-NJeE`
            }
        ]
    },
    {
        date: "2019.06.24",
        title: `Server Side Rendering With JavaScript`,
        subtitle: `Prezentacja na meet.js Wrocław`,
        links: [
            {
                kind: "event",
                value: `https://www.meetup.com/meet-js-wroclaw/events/jvdlcryzjbgc/`
            }
        ]
    },
    {
        date: "2019.04.03",
        title: `A saner approach to testing`,
        subtitle: `Artykuł dla X-Team`,
        links: [
            {
                kind: "article",
                value: `https://x-team.com/blog/saner-approach-to-testing/`
            }
        ]
    },
    {
        date: "2019.02.25",
        title: `Praca zdalna, TypeOfWeb i JS`,
        subtitle: `Podcast Fullstak`,
        links: [
            {
                kind: "link",
                value: `https://fullstak.pl/2`
            }
        ]
    },
    {
        date: "2018.08.31",
        title: `Server-Side Rendering i JavaScript`,
        subtitle: `Prezentacja na meet.js Szczecin`,
        links: [
            {
                kind: "video",
                value: `https://www.youtube.com/watch?v=eQEOAflR7uc`
            },
            {
                kind: "event",
                value: `https://www.meetup.com/meetjs-szczecin/events/254002857/`
            }
        ]
    },
    {
        date: "2018.06.21",
        title: `What's the reason to use Reason?`,
        subtitle: `Prezentacja na meet.js Gdańsk`,
        links: [
            {
                kind: "event",
                value: `https://www.facebook.com/events/1289980281132172/`
            }
        ]
    },
    {
        date: "2018.04.03",
        title: `Kiedyś próbowałem wytłumaczyć teściowi, co to jest Kubernetes`,
        subtitle: `Rozmowa w Just Geek It`,
        links: [
            {
                kind: "article",
                value: `https://geek.justjoin.it/wiekszosc-przedmiotow-studiach-strata-czasu-karol-stepniewski-vmware/`
            }
        ]
    },
    {
        date: "2018.03.28",
        title: `Michał Miszczyszyn on wizards and wands`,
        subtitle: `Wywiad dla X-Team`,
        links: [
            {
                kind: "article",
                value: `https://x-team.com/blog/interview-michal-miszczyszyn/`
            }
        ]
    },
    {
        date: "2018.03.22",
        title: `Wprowadzenie do strumieni`,
        subtitle: `Prezentacja na Angular Tricity #1`,
        links: [
            {
                kind: "event",
                value: `https://crossweb.pl/en/events/angular-tricity-1`
            }
        ]
    },
    {
        date: "2018.03.15",
        title: `Przeszłość i przyszłość tworzenia aplikacji Internetowych`,
        subtitle: `Prezentacja na ByteBay 2018`,
        links: [
            {
                kind: "event",
                value: `https://bytebay.pl/2018/speakers/#speaker-19`
            }
        ]
    },
    {
        date: "2018.03.05",
        title: `Fefaq – nowa aplikacja z pytaniami rekrutacyjnymi dla frontendowców`,
        subtitle: `Wywiad dla Just Geek It`,
        links: [
            {
                kind: "article",
                value: `https://geek.justjoin.it/fefaq-nowa-aplikacja-z-pytaniami-rekrutacyjnymi-dla-frontendowcow/`
            }
        ]
    },
    {
        date: "2018.02.21",
        title: `Od Juniora do Seniora: Odpowiedzi na pytania społeczności #3`,
        subtitle: `Artykuł dla Just Geek It`,
        links: [
            {
                kind: "article",
                value: `https://geek.justjoin.it/juniora-seniora-odpowiedzi-pytania-spolecznosci-3/`
            }
        ]
    },
    {
        date: "2018.02.01",
        title: `Od Juniora do Seniora: Odpowiedzi na pytania społeczności #1`,
        subtitle: `Artykuł dla Just Geek It`,
        links: [
            {
                kind: "article",
                value: `https://geek.justjoin.it/od-juniora-do-seniora-odpowiedzi-na-pytania-spolecznosci-1/`
            }
        ]
    },
    {
        date: "2017.12.13",
        title: `CSS Hacking`,
        subtitle: `Prezentacja na meet.js Gdańsk`,
        links: [
            {
                kind: "event",
                value: `https://www.facebook.com/events/149652705793012/`
            }
        ]
    },
    {
        date: "2017.10.24",
        title: `Hacking with CSS: A New Range of Vulnerabilities`,
        subtitle: `Prezentacja na UnleashConf`,
        links: [
            {
                kind: "video",
                value: `https://youtu.be/VStxR3KCAKM`
            },
            {
                kind: "presentation",
                value: `https://github.com/typeofweb/unleashconf-css-hacking-2017`
            },
            {
                kind: "event",
                value: `https://x-team.com/unleashconf/`
            }
        ]
    },
    {
        date: "2017.10.11",
        title: `6 simple examples which will make you love observables (rxjs 5)`,
        subtitle: `Artykuł dla X-Team`,
        links: [
            {
                kind: "article",
                value: `https://x-team.com/blog/rxjs-observables/`
            }
        ]
    },
    {
        date: "2017.09.28",
        title: `Polscy programiści na świecie #3!`,
        subtitle: `Livestream dla Just Join IT`,
        links: [
            {
                kind: "video",
                value: `https://www.youtube.com/watch?v=7QYy_cPY0vw`
            }
        ]
    },
    {
        date: "2017.09.18",
        title: `Wywiad dla Zbyszka Tenerowicza na meet.js Summit 2018`,
        subtitle: ``,
        links: [
            {
                kind: "link",
                value: `https://soundcloud.com/naugtur/meetjs-summit-2017-od-zaplecza)`
            }
        ]
    },
    {
        date: "2016.11.28",
        title: `I Ty możesz być cyfrowym nomadą!`,
        subtitle: `Prezentacja na PyGDA #20`,
        links: [
            {
                kind: "presentation",
                value: `https://typeofweb.github.io/2016-11-28.PyGda/`
            },
            {
                kind: "event",
                value: `https://www.meetup.com/PyGda-pl/events/235402519/`
            }
        ]
    },
    {
        date: "2016.11.26",
        title: `TDD and TypeScript`,
        subtitle: `Warsztat dla XFive`,
        links: []
    },
    {
        date: "2016.11.15",
        title: `36 Angular 2 - O co tyle krzyku?`,
        subtitle: `Prezentacja na tech.3camp`,
        links: [
            {
                kind: "video",
                value: `https://vimeo.com/192910605`
            },
            {
                kind: "event",
                value: `https://evenea.pl/event/tech3camp151116/`
            },
            {
                kind: "presentation",
                value: `https://typeofweb.github.io/3camp-angular-2-slides/#/1)`
            }
        ]
    },
    {
        date: "2016.10.21",
        title: `Why code readability matters?`,
        subtitle: `Webinar dla XFive`,
        links: []
    },
    {
        date: "2015.03.10",
        title: `Everything You Always Wanted to Know About AngularJS But Were Afraid to Ask`,
        subtitle: `Prezentacja na meet.js Szczecin`,
        links: [
            {
                kind: "presentation",
                value: `https://speakerdeck.com/typeofweb/everything-you-always-wanted-to-know-about-angularjs-but-were-afraid-to-ask`
            }
        ]
    },
    {
        date: "2014.11.20",
        title: `AngularJS 1.3.0 - let's talk about changes!`,
        subtitle: `Prezentacja na ng-poznan #6`,
        links: [
            {
                kind: "presentation",
                value: `https://speakerdeck.com/typeofweb/angularjs-1-dot-3-0-lets-talk-about-changes-ngpoznan`
            },
            {
                kind: "presentation",
                value: `http://typeofweb.github.io/angular-comparison/`
            },
            {
                kind: "code",
                value: `https://github.com/typeofweb/angular-comparison/`
            },
            {
                kind: "event",
                value: `https://www.meetup.com/ng-poznan-meetup/events/211926672/`
            }
        ]
    },
    {
        date: "2014.09.27",
        title: `Wywiad dla meet.js Summit 2014`,
        subtitle: ``,
        links: [
            {
                kind: "video",
                value: `https://www.youtube.com/watch?v=UvBegle7x-A`
            }
        ]
    },
    {
        date: "2014.07.02",
        title: `Case study aplikacji mobilnej w AngularJS: W 8 godzin od pomysłu do implementacji`,
        subtitle: `Prezentacja na meet.js Gdańsk`,
        links: [
            {
                kind: "video",
                value: `https://www.youtube.com/watch?v=OVWomXA-a2s`
            },
            {
                kind: "presentation",
                value: `https://speakerdeck.com/typeofweb/case-study-aplikacji-mobilnej-w-angularjs-w-8-godzin-od-pomyslu-do-implementacji`
            },
            {
                kind: "code",
                value: `https://github.com/typeofweb/lunch-button/tree/meet_js`
            }
        ]
    },
    {
        date: "2013.03.11",
        title: `JavaScript: Kto w ogóle chciałby w tym kodzić?`,
        subtitle: `Prezentacja na meet.js Gdańsk`,
        links: [
            {
                kind: "presentation",
                value: `https://github.com/meetjspl/gdansk/blob/300eff7562e19af0925bf27b37afff2f83bcc90c/media/1/presentation-mm.pdf`
            },
            {
                kind: "event",
                value: `https://www.facebook.com/events/471484796247910/`
            }
        ]
    }
];
const kindToLabelIcon = {
    article: {
        icon: document_text,
        label: "Artykuł"
    },
    code: {
        icon: terminal,
        label: "Kod"
    },
    event: {
        icon: calendar,
        label: "Wydarzenie"
    },
    link: {
        icon: external_link,
        label: "Link"
    },
    presentation: {
        icon: presentation_chart_line,
        label: "Prezentacja"
    },
    video: {
        icon: video,
        label: "Film"
    }
};
function formatDate(dateStr) {
    const months = [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "września",
        "października",
        "listopada",
        "grudnia"
    ];
    const [year, month, day] = dateStr.split(".").map(Number);
    return `${day} ${months[month - 1]} ${year}`;
}
const Timeline = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "m-0 p-2 bg-gray-100 rounded-xl sm:p-5 xl:p-6",
        children: items.slice().sort((a, b)=>{
            if (a.stillOn === b.stillOn) {
                return b.date.localeCompare(a.date);
            }
            return Number(a.stillOn) - Number(b.stillOn);
        }).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "group",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "relative grid items-start px-3 py-4 hover:bg-white rounded-xl overflow-hidden transition-colors sm:px-5 md:grid-cols-12 xl:grid-cols-10 xl:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "mb-1 ml-9 text-gray-900 font-bold md:col-span-8 md:col-start-5 md:ml-0 xl:col-span-6 xl:col-start-5",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                            dateTime: "2021-06-17T19:00:00.000Z",
                            className: "flex row-start-1 items-center mb-1 font-medium md:col-span-4 md:col-start-1 md:row-end-3 md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    viewBox: "0 0 24 24",
                                    className: "mr-6 w-5 h-5 text-gray-300 group-hover:text-pink-500 overflow-visible transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "12",
                                            cy: "12",
                                            r: "6",
                                            fill: "currentColor"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "12",
                                            cy: "12",
                                            r: "11",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M 12 -6 V -64",
                                            fill: "none",
                                            strokeWidth: "2",
                                            stroke: "currentColor",
                                            className: "group-first:hidden text-gray-200"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M 12 30 V 500",
                                            fill: "none",
                                            strokeWidth: "2",
                                            stroke: "currentColor",
                                            className: "group-last:hidden text-gray-200"
                                        })
                                    ]
                                }),
                                formatDate(item.date),
                                item.stillOn ? ` –${NBSP}dziś` : ""
                            ]
                        }),
                        item.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "ml-9 text-gray-900 font-serif text-base md:col-span-8 md:col-start-5 md:ml-0 xl:col-span-6",
                            children: item.subtitle
                        }),
                        item.links.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-row gap-4 ml-9 md:col-span-8 md:col-start-5 md:ml-0 xl:col-span-6 xl:col-start-5",
                            children: item.links.map((link)=>{
                                const Icon = kindToLabelIcon[link.kind].icon;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: link.value,
                                        className: "inline-flex gap-1 items-center mt-1 hover:text-blue-500 text-gray-900 font-sans text-base transition-colors",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                className: "-ml-0.5 w-5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mt-1",
                                                children: kindToLabelIcon[link.kind].label
                                            })
                                        ]
                                    })
                                }, link.value);
                            })
                        })
                    ]
                })
            }, item.date + item.title))
    });
};

;// CONCATENATED MODULE: ./components/MDXComponent.tsx










const MDXComponent = /*#__PURE__*/ (0,react.memo)((props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXRemote, {
        ...props,
        components: components
    });
});
MDXComponent.displayName = "MDXComponent";
const warned = {};
const isLocalUrl = (href)=>{
    try {
        return new URL(href, constants/* host */.ho).hostname === constants/* origin */.hW;
    } catch  {
        return false;
    }
};
const A = (param)=>{
    let { href , ref , ...props } = param;
    if (!href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            ...props
        });
    }
    return isLocalUrl(href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            ...props
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            ...props
        })
    });
};
const Img = (param)=>{
    let { src , width , height , alt ="" , placeholder: _placeholder , ...props } = param;
    if (!src) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {});
    }
    const srcWithoutPublic = src.replace(/^\/public\//, "/");
    if (width && height && srcWithoutPublic) {
        // const isFull = props.className?.includes('size-full') ?? false;
        // const isLarge = props.className?.includes('size-large') ?? false;
        // const isMedium = props.className?.includes('size-medium') ?? false;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${props.className ?? ""} img`,
            style: {
                maxWidth: Number(width),
                maxHeight: Number(height)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                ...props,
                width: Number(width),
                height: Number(height),
                src: srcWithoutPublic,
                alt: alt,
                loading: "lazy",
                priority: false,
                layout: "responsive"
            })
        });
    }
    // console.warn(`[MDX] Image ${src} has no width and height.`);
    // eslint-disable-next-line @next/next/no-img-element -- ok
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ...props,
        width: width,
        height: height,
        src: srcWithoutPublic,
        alt: alt,
        loading: "lazy"
    });
};
const NewsletterForm = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8958)).then((m)=>m.NewsletterForm), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8958)
            ]
    }
});
const FacebookPageWidget = ()=>{
    if (!warned["FacebookPageWidget"]) {
        console.warn(`Not implemented: FacebookPageWidget`);
        warned["FacebookPageWidget"] = true;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
const CodepenWidget = dynamic_default()(()=>__webpack_require__.e(/* import() | CodepenWidget */ 483).then(__webpack_require__.bind(__webpack_require__, 4598)).then((m)=>m.CodepenWidget), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4598)
            ]
    },
    ssr: false
});
const groupByImagesAndDescriptions = (children)=>{
    const imgStartIndexes = children.flatMap((child, index)=>{
        if (child.props.originalType === "img" || child.props.mdxType === "img") {
            return [
                index
            ];
        }
        if (typeof child.type === "function" && child.type.name === "Image") {
            return [
                index
            ];
        }
        return [];
    });
    const imgEndIndexes = imgStartIndexes.slice(1);
    const groups = imgStartIndexes.map((startIndex, idx)=>children.slice(startIndex, startIndex + imgEndIndexes[idx] || Infinity));
    return groups;
};
const splitDescriptionIntoLines = (description)=>{
    if ((description.props.mdxType === "p" || description.props.originalType === "p") && (typeof description.props.children === "string" || Array.isArray(description.props.children) && description.props.children.every((s)=>typeof s === "string"))) {
        return [
            description.props.children
        ].flat().join("").trim().split("\n").filter((line)=>!!line.trim()).map((line, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: line
            }, String(idx) + line));
    }
    return description;
};
const Gallery = (param)=>{
    let { // eslint-disable-next-line @typescript-eslint/no-unused-vars -- @todo
    columns ="2" , // eslint-disable-next-line @typescript-eslint/no-unused-vars -- @todo
    link ="none" , // eslint-disable-next-line @typescript-eslint/no-unused-vars -- @todo
    size ="medium" , children  } = param;
    const groups = groupByImagesAndDescriptions(children);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `md:grid ${columns === "1" ? "md:grid-cols-1" : columns === "2" ? "md:grid-cols-2" : "md:grid-cols-3"} md:-mx-16`,
        children: groups.map((param, idx)=>{
            let [img, ...descriptions] = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                className: "w-full",
                children: [
                    img,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        children: descriptions.flatMap((d)=>splitDescriptionIntoLines(d))
                    })
                ]
            }, String(idx) + (img.props.src || ""));
        })
    });
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- have to cast
const components = {
    a: A,
    img: Img,
    Img,
    Image: (image_default()),
    NewsletterForm,
    FacebookPageWidget,
    CodepenWidget,
    Gallery,
    Timeline: Timeline,
    DemoSimulation: DemoSimulation
};

// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
// EXTERNAL MODULE: ./components/molecules/NewsletterForm.tsx + 1 modules
var molecules_NewsletterForm = __webpack_require__(8958);
// EXTERNAL MODULE: ./components/atoms/ArticleCoverImage.tsx
var ArticleCoverImage = __webpack_require__(9655);
// EXTERNAL MODULE: ./components/atoms/ArticleTitle.tsx
var ArticleTitle = __webpack_require__(2298);
// EXTERNAL MODULE: ./components/atoms/Card.tsx
var Card = __webpack_require__(2409);
;// CONCATENATED MODULE: ./components/atoms/GitHubEditLink.tsx


const repo = `https://github.com/typeofweb-org/typeofweb.com/edit/main/`;
const GitHubEditLink_NBSP = "\xa0";
const GitHubEditLink = (param)=>{
    let { filePath  } = param;
    const url = `${repo}${filePath}`;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-5 text-center text-gray-900 whitespace-nowrap text-xl font-bold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "block",
                children: [
                    "\uD83D\uDC49",
                    GitHubEditLink_NBSP,
                    GitHubEditLink_NBSP,
                    "Znalazłeś/aś błąd?",
                    GitHubEditLink_NBSP,
                    GitHubEditLink_NBSP,
                    "\uD83D\uDC48"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: url,
                        className: "text-blue-500",
                        children: "Edytuj ten wpis na GitHubie!"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./images/typeofweb-pattern.svg
var _symbol, _use, _use2, _use3;

function typeofweb_pattern_extends() { typeofweb_pattern_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return typeofweb_pattern_extends.apply(this, arguments); }



const SvgTypeofwebPattern = props => /*#__PURE__*/react.createElement("svg", typeofweb_pattern_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 128 22"
}, props), _symbol || (_symbol = /*#__PURE__*/react.createElement("symbol", {
  id: "a"
}, /*#__PURE__*/react.createElement("path", {
  d: "m2.3 10.8 7.9 3.2-.6 1.7-9.6-4V9.9l9.6-4.1.6 1.7zM13 21.5h-2.2L18.4 0h2.1zm8.1-14 .6-1.7 9.6 4.1v1.8l-9.6 4-.6-1.7 7.9-3.2z"
}))), _use || (_use = /*#__PURE__*/react.createElement("use", {
  href: "#a"
})), _use2 || (_use2 = /*#__PURE__*/react.createElement("use", {
  x: 48,
  href: "#a"
})), _use3 || (_use3 = /*#__PURE__*/react.createElement("use", {
  x: 96,
  href: "#a"
})));

/* harmony default export */ var typeofweb_pattern = (SvgTypeofwebPattern);
// EXTERNAL MODULE: ./components/atoms/SectionTitle.tsx
var SectionTitle = __webpack_require__(3895);
// EXTERNAL MODULE: ./components/molecules/SocialWidget.tsx + 7 modules
var SocialWidget = __webpack_require__(8467);
;// CONCATENATED MODULE: ./components/molecules/ArticleFooter.tsx






const getAuthorsTitle = (authors)=>{
    if (authors.length === 1) {
        return authors[0]?.gender === "f" ? "Autorka" : "Autor";
    }
    return authors.every((a)=>a.gender === "f") ? "Autorki" : "Autorzy";
};
const ArticleFooter = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { authors  } = param;
    const title = getAuthorsTitle(authors);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typeofweb_pattern, {
                className: "mb-6 mt-8 mx-auto w-32 text-green-500"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start mb-4 mt-4 mx-auto px-4 max-w-lg text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        level: "none",
                        size: "small",
                        children: title
                    }),
                    authors.map((a)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            itemScope: true,
                            itemType: "http://schema.org/Person",
                            itemProp: "author",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex flex-wrap items-center my-2 sm:flex-nowrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: `inline-flex border-2 rounded-full border-gray-100 mr-4`,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: a.avatarUrl + `?s=${96}`,
                                                width: 48,
                                                height: 48,
                                                layout: "fixed",
                                                alt: `Zdjęcie ${a.displayName}`,
                                                className: `rounded-full`,
                                                unoptimized: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: ` text-gray-800 inline-block text-lg font-sans font-bold leading-none`,
                                            itemProp: "name",
                                            children: a.displayName
                                        }),
                                        "​",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline-flex mb-2 ml-3 mt-3 sm:-mt-2 sm:mb-0",
                                            children: SocialWidget/* social.filter */.xs.filter((s)=>s.slug in a && !!a[s.slug]).map((param)=>/*#__PURE__*/ {
                                                let { icon: Icon , slug , label  } = param;
                                                return (0,jsx_runtime.jsx)("a", {
                                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- filtered above
                                                    href: a[slug],
                                                    "aria-label": `${a.displayName} ${label}`,
                                                    title: `${a.displayName} ${label}`,
                                                    className: "text-gray-700 hover:text-green-500 transition-colors",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                        className: `mx-2 w-5 ${slug === "website" ? "stroke-current" : "fill-current"}`
                                                    })
                                                }, slug);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 text-gray-900",
                                    children: a.description
                                })
                            ]
                        }, a.slug);
                    })
                ]
            })
        ]
    });
});
ArticleFooter.displayName = "ArticleFooter";

// EXTERNAL MODULE: ./components/molecules/ArticleMeta.tsx
var ArticleMeta = __webpack_require__(1244);
;// CONCATENATED MODULE: ./components/organisms/SingleArticle.tsx










const RelatedArticles = dynamic_default()(()=>__webpack_require__.e(/* import() | RelatedArticles */ 67).then(__webpack_require__.bind(__webpack_require__, 5199)).then((m)=>m.RelatedArticles), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5199)
            ]
    }
});
const Comments = dynamic_default()(()=>__webpack_require__.e(/* import() | Comments */ 329).then(__webpack_require__.bind(__webpack_require__, 1658)).then((m)=>m.Comments), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1658)
            ]
    },
    ssr: false
});
const SingleArticle = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { filePath , cover , index , title , authors , mainCategory , permalink , excerpt , content , isMdx , series , commentsCount  } = param;
    const href = "/" + permalink;
    (0,react.useEffect)(()=>{
        window.dataLayer.push({
            algoliaDisplayedObjectIDs: permalink
        });
    }, [
        permalink
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        as: "article",
        ref: ref,
        className: `${isMdx ? "__mdx" : "__html"}`,
        itemScope: true,
        itemProp: "mainEntity",
        itemType: "http://schema.org/Article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `px-7 sm:px-8 lg:px-12 bg-gray-100 pb-4 pt-8`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTitle/* ArticleTitle */.j, {
                            title: title,
                            href: href,
                            level: 1
                        }),
                        excerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prose mt-8 pb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "lead",
                                children: excerpt
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleMeta/* ArticleMeta */.q, {
                            commentsCount: commentsCount,
                            series: series,
                            rel: true,
                            authors: authors,
                            mainCategory: mainCategory,
                            permalink: permalink,
                            size: "small"
                        }),
                        cover && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCoverImage/* ArticleCoverImage */.p, {
                            cover: cover
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                itemProp: "articleBody",
                className: "prose lg:prose-xl mx-auto pb-2 px-7 sm:px-8 lg:px-12",
                children: content
            }),
            permalink === "wspolpraca" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GitHubEditLink, {
                filePath: filePath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                itemProp: "publisher",
                itemScope: true,
                itemType: "https://schema.org/Organization",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "logo",
                        itemScope: true,
                        itemType: "https://schema.org/ImageObject",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            itemProp: "url",
                            content: "/public/assets/wp-content/uploads/2020/04/logo_kwadrat11.png"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "name",
                        content: "Type of Web"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                itemProp: "mainEntityOfPage",
                href: href
            }),
            index && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleFooter, {
                authors: authors
            }),
            index && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedArticles, {
                permalink: permalink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, {
                postTitle: title
            })
        ]
    });
}));
SingleArticle.displayName = "SingleArticle";

// EXTERNAL MODULE: ./components/templates/TwoColumns.tsx + 6 modules
var TwoColumns = __webpack_require__(7686);
// EXTERNAL MODULE: ./hooks/runningHeader.tsx + 1 modules
var runningHeader = __webpack_require__(536);
// EXTERNAL MODULE: ./pages/index.tsx + 2 modules
var pages = __webpack_require__(2931);
;// CONCATENATED MODULE: ./pages/[permalink]/index.tsx








const PermalinkPage = (props)=>{
    const { setRunningHeader  } = (0,runningHeader/* useRunningHeader */.i)();
    if (props.pageKind === "category") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages["default"], {
            ...props,
            videos: null,
            seriesLinks: null
        });
    }
    const { pageKind , excerpt , frontmatter , filePath , ...contentObj } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TwoColumns/* TwoColumns */.V, {
        withSidebar: true,
        pageKind: pageKind,
        series: frontmatter.series,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                title: frontmatter.seo?.title || frontmatter.title,
                description: frontmatter.seo?.metadesc || excerpt,
                author: frontmatter.authors[0]?.facebook,
                series: frontmatter.series,
                cover: frontmatter.cover
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleArticle, {
                filePath: filePath,
                ref: setRunningHeader,
                excerpt: excerpt,
                isMdx: contentObj.isMdx,
                content: contentObj.isMdx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXComponent, {
                    ...contentObj.content
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: contentObj.content
                    }
                }),
                index: frontmatter.index,
                title: frontmatter.title,
                authors: frontmatter.authors,
                mainCategory: frontmatter.mainCategory,
                permalink: frontmatter.permalink,
                series: frontmatter.series,
                cover: frontmatter.cover ? {
                    ...frontmatter.cover,
                    preload: true
                } : null,
                commentsCount: frontmatter.commentsCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_NewsletterForm.NewsletterForm, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _permalink_ = (PermalinkPage);


/***/ }),

/***/ 2746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
__webpack_unused_export__ = ({ value: true });
/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
if (true) {
    module.exports.jsxRuntime = __webpack_require__(5893);
}
else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,163,536,931,774,888,179], function() { return __webpack_exec__(6907); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);